import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {Lead} from "../lead.model";

export class LeadDgSearchResults extends GenericDgSearchResults {
  public results: Lead[];

  constructor(total: number, results: Lead[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

